export default __webpack_public_path__ + "static/media/bConsulting.b3fa08da.svg";